module.exports = "/lucky-balls/img/bigball/BigBall_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_009.png
// module id = 904
// module chunks = 0